import React from 'react'
import './style.css'

const WelcomeBanner = () => {
    return (
        <>
             <div className="home-main-banner">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="home-banner-text">
                                <h1>Welcome to I-Sit</h1>
                                <p className='common-text'>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Deleniti, cum ad obcaecati in soluta fugiat alias nobis.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default WelcomeBanner